import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {RSDialogComponentModel} from '../../../libs/rsnotify/rsdialog.component.model';
import {Hort360PropertySummary, Meeting} from '../../../../functions/src/types';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {UserService} from '../../services/user.service';
import {RSValidatorFormDirective} from '../../../libs/rsvalidator/rsvalidator.directive';
import {DataService} from '../../services/data.service';
import invert from 'invert-color';
import {PropertyService} from '../../services/property.service';
import {RSDialogService} from '../../../libs/rsnotify/rsdialog.service';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import * as moment from 'moment';
import {MatTab, MatTabGroup} from '@angular/material/tabs';
import {Moment} from 'moment';

@Component({
  selector: 'app-add-meeting',
  templateUrl: './add-meeting.component.html',
  styleUrls: ['./add-meeting.component.scss']
})
export class AddMeetingComponent extends RSDialogComponentModel implements OnInit, AfterViewInit, OnDestroy {
  meeting: Meeting = {} as Meeting;
  @ViewChild('actionButtons', {static: true, read: TemplateRef}) actionButtons: TemplateRef<any>;
  @ViewChild('form') inputForm: RSValidatorFormDirective;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;

  public selectedProperties: Hort360PropertySummary[] = [];
  public propertyAttendees: {[key: number]: number} = {};

  constructor(
    private userService: UserService,
    public dataService: DataService,
    public rsDialogService: RSDialogService,
    public propertyService: PropertyService,
    private fbDB: AngularFirestore
  ) {
    super();

    // Wait for input
    this.dialogValuesUpdated.subscribe(v => {
      this.updateMeeting(v.meeting);
    });
    this.updateMeeting({});
  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

  ngOnInit(): void {  }

  ngOnDestroy() {  }

  ngAfterViewInit(): void {
    this.dialogHandles.buttonTemplateRef = this.actionButtons;
    this.dialogHandles.buttonTemplateAttach();
  }

  public setDate(date: Date | Moment) {
    this.meeting.date = +moment(date).format('X');
  }

  async updateMeeting(input: any) {
    if (!input) {
      input = {};
    }
    this.meeting = {
      id: input.id || null,
      date: input.date || moment().format('X'),
      notes: input.notes || null,
      topic: input.topic || null,
      locationTown: input.locationTown || null,
      locationLga: input.locationLga || null,
    } as Meeting;

    // Do we need to load properties?
    if (this.meeting.id) {
      this.propertyAttendees = {};
      const attendees = await this.fbDB.collection(`meetings/${this.meeting.id}/attendees`).get().toPromise();
      const propertyIds = attendees.docs.map(d => d.id + '');
      attendees.docs.forEach(d => this.propertyAttendees[d.id] = (d.data() || {} as any).total || 1);
      this.selectedProperties = this.propertyService.getPropertySummaries(propertyIds);
    }

    // Done!
    console.log('updateMeeting::: ', this.meeting, this.selectedProperties, this.propertyAttendees);
  }

  close() {
    this.dialogHandles.close(RSDialog.defaultValues.CANCEL);
  }

  updatePropertyAttendee(property: Hort360PropertySummary, total: number) {
    this.propertyAttendees[property.id] += total;
    if (this.propertyAttendees[property.id] < 0) {
      this.propertyAttendees[property.id] = 0;
    }
  }

  async selectProperty(property: Hort360PropertySummary) {
    const index = this.selectedProperties.findIndex(p => p.id === property.id);
    if (index !== -1) {
      // ARE YOU SURE?
      const bSure = await this.rsDialogService.showConfirmDialog(
        `Are you sure you want to remove '${property.name}' from this meeting?`, false, 'Remove', RSDialog.Style.WARN);
      if (bSure) {
        this.selectedProperties.splice(index, 1);
        delete this.propertyAttendees[property.id];
      }
    } else {
      this.selectedProperties.push(property);
      this.propertyAttendees[property.id] = 1;
    }
  }

  nextTab() {
    if (!this.inputForm.isValid(true)) {
      return;
    } else {
      this.tabGroup.selectedIndex = 1;
    }
  }

  saveMeeting() {
    if (!this.inputForm.isValid(true)) {
      this.tabGroup.selectedIndex = 0;
      return;
    } else {
      this.dialogValues.meeting = this.meeting;
      this.dialogValues.propertyAttendees = this.propertyAttendees;
      this.dialogHandles.close(RSDialog.defaultValues.YES);
    }
  }

}
